module.exports = __webpack_public_path__ + "static/media/aggjakten2026_u12.3fd7d243.jpg";